export const Waiting = () => {
  return (
    <div className="modal-backdrop show" style={{ opacity: 0.9 }}>
      <div
        className={'min-vh-70 d-flex justify-content-center align-items-center'}
      >
        <div
          className="spinner-border text-white"
          style={{
            width: '4rem',
            height: '4rem',
            border: '0.50em solid var(--red)',
            borderRightColor: 'transparent',
          }}
          role="status"
        ></div>
      </div>
    </div>
  );
};
